import { useEffect, useState } from 'react'

export type Font = {
  family: string
  url: string
  options: FontFaceDescriptors
}

const defaultFonts: Font[] = [
  {
    family: 'Neue World',
    url: '/fonts/PPNeueWorld-SemiCondensedUltralight.woff2',
    options: {
      style: 'normal',
      weight: '400',
      display: 'block',
    },
  },
  {
    family: 'Overpass Mono',
    url: '/fonts/OverpassMono-Regular.woff2',
    options: {
      style: 'normal',
      weight: '400',
      display: 'block',
    },
  },
]

export const useFonts = (fonts: Font[] = defaultFonts) => {
  const [fontFaces] = useState(
    fonts.map((font) => {
      return new FontFace(
        font.family,
        `url(${font.url}) format("woff2")`,
        font.options
      )
    })
  )

  const [loaded, setLoaded] = useState(false)

  async function loadFontFace(fontFace: FontFace) {
    const loadedFont = await fontFace.load()
    document.fonts.add(loadedFont)
  }

  useEffect(() => {
    Promise.all(fontFaces.map(loadFontFace)).then(() => {
      setLoaded(true)
    })
  }, [fontFaces])

  return loaded
}
